<template>
  <div>
    <v-btn color="#1A8D2B" class="ml-10 white--text" @click="toggle"
      >full screen</v-btn
    >
    <fullscreen ref="fullscreen" @change="fullscreenChange" background="#EEE">
      <v-container class="d-flex flex-column justify-space-around">
        <h1 class="text-center mb-2">{{ masjid.name }}</h1>
        <div class="d-flex flex-row justify-space-around">
          <div class="d-flex flex-column">
            <v-card class="mb-4">
              <v-toolbar flat color="#1A8D2B" class="white--text">
                <v-toolbar-title class="mx-auto">Jadwal Sholat</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <table style="width: 100%">
                  <tr>
                    <th colspan="2" style="text-align: left">
                      {{ sholat.tanggal }}
                    </th>
                  </tr>
                  <tr>
                    <td>Subuh</td>
                    <td>: {{sholat.subuh}}</td>
                  </tr>
                  <tr>
                    <td>Dzuhur</td>
                    <td>: {{sholat.dzuhur}}</td>
                  </tr>
                  <tr>
                    <td>Ashar</td>
                    <td>: {{sholat.ashar}}</td>
                  </tr>
                  <tr>
                    <td>Maghrib</td>
                    <td>: {{sholat.maghrib}}</td>
                  </tr>
                  <tr>
                    <td>Isya</td>
                    <td>: {{sholat.isya}}</td>
                  </tr>
                </table>
              </v-card-text>
            </v-card>
            <v-card>
              <v-toolbar flat color="#1A8D2B" class="white--text">
                <v-toolbar-title class="mx-auto"
                  >Laporan Keuangan</v-toolbar-title
                >
              </v-toolbar>
              <v-card-text>
                <table style="width: 100%">
                  <tr>
                    <th colspan="2" style="text-align: left">
                      {{ sholat.tanggal }}
                    </th>
                  </tr>
                  <tr>
                    <td>Masuk</td>
                    <td>: Rp {{keuangan.income.toLocaleString("id-ID")}}</td>
                  </tr>
                  <tr>
                    <td>Keluar</td>
                    <td>: Rp {{keuangan.expenses.toLocaleString("id-ID")}}</td>
                  </tr>
                  <tr>
                    <td>Saldo</td>
                    <td>: Rp {{keuangan.balances.toLocaleString("id-ID")}}</td>
                  </tr>
                </table>
              </v-card-text>
            </v-card>
          </div>
          <div class="d-flex flex-column">
            <v-card flat outlined height="525px" width="500px">
              <v-img
                v-if="masjid == undefined || !isImages"
                class="mx-4"
                contain
                src="../../assets/mosque-noimage.png"
              />

              <v-container v-if="masjid != undefined">
                <v-carousel
                  v-if="masjid.images && masjid.images.length"
                  cycle
                  interval="4000"
                  :show-arrows="true"
                >
                  <v-carousel-item
                    v-for="(img, i) in masjid.images"
                    :key="i"
                    class="white--text align-end"
                    :src="img.url"
                    contain
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-carousel-item>
                </v-carousel>
              </v-container>
            </v-card>
          </div>
          <div class="d-flex flex-column">
            <v-card class="mb-4 scroller" max-height="330">
              <v-toolbar flat color="#1A8D2B" class="white--text">
                <v-toolbar-title class="mx-auto">
                  Jadwal Kegiatan
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text v-for="(item, i) in itemKegiatan" :key="i">
                {{ item.start_date }}
                {{ item.start_time.substr(0, 5) }}
                <br />
                {{ item.name }}
              </v-card-text>
            </v-card>
            <v-card>
              <v-toolbar flat color="#1A8D2B" class="white--text">
                <v-toolbar-title class="mx-auto"
                  >Petugas Sholat Jum'at</v-toolbar-title
                >
              </v-toolbar>
              <v-card-text>
                <table style="width: 100%">
                  <tr>
                    <th colspan="2" style="text-align: left">
                      {{this.$moment(soljum.date).format("dddd, D MMMM YYYY")}}
                    </th>
                  </tr>
                  <tr>
                    <td>Khatib</td>
                    <td>: {{soljum.khatib}}</td>
                  </tr>
                  <tr>
                    <td>Muadzin</td>
                    <td>: {{soljum.muadzin}}</td>
                  </tr>
                </table>
              </v-card-text>
            </v-card>
          </div>
        </div>

        <div class="d-flex flex-row justify-space-around mt-10">
          <v-card color="#1A8D2B" width="600" height="200" class="white--text mb-4 overflow-y-auto surah">
            <v-img
              src="../../assets/logoSurah.png"
              height="30px"
              width="40px"
              class="mx-auto mt-4"
            ></v-img>
            <v-card-text class="white--text text-center">
              <p>
                {{surat.acak.id.teks}}
              <br />
              (QS. {{surat.surat.name}}:{{surat.surat.ayat}})
              </p>
            </v-card-text>
          </v-card>
          <v-card color="#1A8D2B" width="600" height="200" class="white--text ml-4 mb-4 overflow-y-auto hadist">
            <v-img
              src="../../assets/logoHadist.png"
              height="40px"
              width="30px"
              class="mx-auto mt-3"
            ></v-img>
            <v-card-text class="white--text text-center">
              <p>
                {{hadist.terjemah}}
                <br />
                (Shahih Bukhari: {{hadist.id}})
              </p>
            </v-card-text>
          </v-card>
        </div>
      </v-container>
    </fullscreen>
  </div>
</template>

<style scoped>
.scroller {
  overflow-y: auto;
}
.scroller::-webkit-scrollbar {
  display: none;
}
.hadist::-webkit-scrollbar {
  display: none;
}
.surah::-webkit-scrollbar {
  display: none;
}
</style>

<script>
import fullscreen from "vue-fullscreen";
import Vue from "vue";
Vue.use(fullscreen);

export default {
  data() {
    return {
      masjid: {},
      itemKegiatan: [],
      isImages: false,
      fullscreen: false,
      sholat: {},
      surat: {},
      ranHadistId: 0,
      hadist: null,
      kota: "",
      keuangan: {
        income: 0,
        expenses: 0,
        balances: 0
      },
      soljum : {}
    };
  },
  methods: {
    toggle() {
      this.$refs["fullscreen"].toggle(); // recommended
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },
    randomHadistId() {
      this.ranHadistId = Math.floor((Math.random() * 7008) + 1);
    },
    sortingItems(a, b) {
      if (a.date > b.date) {
        return -1;
      }
      if (a.date < b.date) {
        return 1;
      }
      return 0;
    },
  },
  async created() {
    await this.axios(`/masjid/detail/${localStorage.getItem("masjid")}`)
      .then((response) => {
        this.masjid = response.data.data;
        if (this.masjid.images.length != 0) this.isImages = true;
        this.kota = this.masjid.city
      })
      .catch((error) => {
        console.log(error);
      });

    this.axios("/program/list")
      .then((response) => {
        for(let i = 0; i < response.data.data.length; i++) {
          if(response.data.data[i].type == "eventual"){
            // console.log(response.data.data[i])
            response.data.data[i].start_date = this.$moment(response.data.data[i].start_date).format("dddd, D MMMM YYYY")
            this.itemKegiatan.push(response.data.data[i])
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
    
    // FETCH JADWAL SHOLAT
    //note: karena dalam proses development maka digunakan api dgn proxy, harap rubah api tersebut setelah fase produksi seperti yang tertera pada dokumentasi di link sumber dibawah
    //sumber: https://fathimah.docs.apiary.io/#
    let tanggal = new Date().toISOString().substr(0, 10)
    let kodeKota = null
    this.axios(`https://private-anon-a7a368bbf3-fathimah.apiary-proxy.com/sholat/format/json/kota/nama/${this.kota}`)
    .then((response) => {
      kodeKota = response.data.kota[0].id
      return this.axios(`https://private-anon-a7a368bbf3-fathimah.apiary-proxy.com/sholat/format/json/jadwal/kota/${kodeKota}/tanggal/${tanggal}`)
    })
    .then((response) => {
      this.sholat = response.data.jadwal.data
    })
    .catch((error) => {
      console.log(error, 'error fetch jadwal sholat')
    })

    //FETCH SURAH
    //note: karena dalam proses development maka digunakan api dgn proxy, harap rubah api tersebut setelah fase produksi seperti yang tertera pada dokumentasi di link sumber dibawah
    //sumber: https://fathimah.docs.apiary.io/#
    this.axios("https://private-anon-a7a368bbf3-fathimah.apiary-proxy.com/quran/format/json/acak")
    .then((response) => {
      this.surat = response.data
    })
    .catch((error) => {
      console.log(error)
    })

    //FETCH HADIST KITAB SHAHIH BUKHARI
    //note: karena dalam proses development maka digunakan api dengan tambahan "cors-anywhere", harap rubah api tersebut setelah fase produksi seperti yang tertera pada dokumentasi di link sumber dibawah
    //sumber: <API Hadist> http://core.carihadis.com/
    //sumber: <cors> https://github.com/Rob--W/cors-anywhere
    this.randomHadistId()
    this.axios(`https://cors-anywhere.herokuapp.com/http://api.carihadis.com/?kitab=Shahih_Bukhari&id=${this.ranHadistId}`)
    .then((response) => {
      this.hadist = response.data.data[1]
      // console.log(this.hadist , 'hadist random')
    })
    .catch((error) => {
      console.log(error, 'error fetch hadist')
    })

    this.axios("/keuangan/list")
    .then((res) => {
      console.log(res.data.data, "res fetch data keuangan")
      res.data.data.map(el => {
        if(el.transaction == "in") {
          this.keuangan.income += Number(el.value)
        }else{
          this.keuangan.expenses += Number(el.value)
        }
      })
      this.keuangan.balances = this.keuangan.income - this.keuangan.expenses
    })
    .catch((err) => {
      console.log(err, "error fetch keuangan")
    })

    this.axios("/masjid/soljum/list")
    .then((res) => {
      console.log(res.data.data, 'res fetch soljum')
      let items = res.data.data

      items.sort(this.sortingItems)
      this.soljum = items[0]
      console.log(this.soljum, "data soljum")
    })
    .catch((err) => {
      console.log(err, "error fetch soljum")
    })
  },
};
</script>

<style>
</style>